export class OccurrenceFilterModel {
  contractId!: string;
  device: any = null;
  type!: string;
  lane!: number;
  operation!: string;
  rejected!: string;
  motive!: string;
  motiveOccurrence!: string;
  hasAttachment!: boolean;
  hasNotes!: boolean;
  endDate!: string;
  startDate!: string;

  constructor() {
    // @ts-ignore
    this.endDate = new Date();
    // @ts-ignore
    this.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
  }
}